"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaxNumberChangeEvents = void 0;
var TaxNumberChangeEvents = exports.TaxNumberChangeEvents = /*#__PURE__*/function (TaxNumberChangeEvents) {
  TaxNumberChangeEvents["UPDATE"] = "UPDATE";
  TaxNumberChangeEvents["SAVE"] = "SAVE";
  TaxNumberChangeEvents["NONE"] = "NONE";
  return TaxNumberChangeEvents;
}(TaxNumberChangeEvents || {});